module.exports = new __parcel__URL__("jpd-matrix-blank-darkmode.9079c7d3.svg").toString();